import { render, staticRenderFns } from "./senEmail.vue?vue&type=template&id=1ef9d43c&scoped=true&"
import script from "./senEmail.vue?vue&type=script&lang=js&"
export * from "./senEmail.vue?vue&type=script&lang=js&"
import style0 from "./senEmail.vue?vue&type=style&index=0&id=1ef9d43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9d43c",
  null
  
)

export default component.exports